export enum UrlSearchParams {
  ASK_AGENT = 'ask_agent',
  DP_BOX = 'dpbox',
  DP_CITY = 'dpcity',
  DP_EAN_ELECTRICITY = 'dpeanel',
  DP_EAN_GAS = 'dpeanng',
  DP_NUMBER = 'dpnumber',
  DP_STREET = 'dpstreet',
  DP_ZIP = 'dpzip',
  OPPORTUNITY_ID = 'opportunityId',
  REFERRAL_CODE = 'referralcode',
  SALESFORCE_USER_ALIAS = 'sfu',
  SIMULATION_SALES_OFFICE = 'simulation_so',
  SKIP_ITSME = 'skip_itsme',
  DYNAMIC_TARIFF = 'dynamic_tariff',
  SETTLEMENT_FREQUENCY_MONTHLY = 'settlement_frequency_monthly'
}
